module.exports = __webpack_public_path__ + "e21e4fa54dfc55d7fb466a679de8b389.svg";